










import { defineComponent, PropType } from "@vue/composition-api";

/**
 * 基础按钮
 */
export default defineComponent({
  props: {
    // "primary" | "secondary" | "tertiary" | "danger" | "success" | "primary-fill" | "secondary-light"
    type: {
      type: String,
      default: "primary",
    },
    // "small" | "medium" | "large"
    size: {
      type: String,
      default: "medium",
    },
    iconName: {
      type: String,
      default: "",
    },
  },
  name: "baseButton",
});
